import { NgModule } from '@angular/core';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { SelectModule, RadioGroupModule, TextInputModule, SmartModalModule } from '@certemy/ui-components';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LocationsCountryModalComponent } from 'services/locations/modals/locations-country-modal/locations-country-modal.component';
import { LocationsRegionModalComponent } from 'services/locations/modals/locations-region-modal/locations-region-modal.component';
import { LocationsOfficeModalComponent } from 'services/locations/modals/locations-office-modal/locations-office-modal.component';
import { LocationsService } from 'services/locations/locations.service';
import { InlineErrorModule } from 'components/errors/inline-error.module';

@NgModule({
  imports: [
    CertemyCommonModule,
    SmartModalModule.forRoot(),
    SelectModule,
    NgbTooltipModule,
    RadioGroupModule,
    TextInputModule,
    InlineErrorModule,
  ],
  declarations: [LocationsCountryModalComponent, LocationsRegionModalComponent, LocationsOfficeModalComponent],
  providers: [LocationsService],
})
export class LocationsModule {}
